import { MInvoiceUser } from '@Models/client/my-account.model'
import moment from 'moment'
import { CommonService } from '@Services/common.service'

// models section
interface IAccountInfo {
    user?: MInvoiceUser
    createdAt?: string
}

const AccountInfo = (props: IAccountInfo) => {
    // core section
    const { user, createdAt } = props

    // functions section
    const honorificsGenerate = (gender?: string) => {
        if (gender === 'FEMALE') return 'Mrs/Ms. '
        return 'Mr. '
    }

    // main section
    return (
        <div
            // style={{ width: '350px' }}
            className="page-border page-border-radius px-4 py-2 d-flex justify-content-between invoice-account-info"
        >
            <div className="w-50">
                <p className="fs-16 main-text font-weight-bold m-0 username">
                    SFP
                </p>
                <p className="light-gray-text mb-2 address">
                    123212 San Francisco St San Francisco CA 93003
                </p>
                <p className="black-text font-weight-bold m-0 username">
                    {honorificsGenerate(user?.gender)}{' '}
                    {CommonService.textCapitalize(user?.username || '')}
                </p>
                <p className="light-gray-text m-0 address">{user?.address}</p>
            </div>
            <p className="light-gray-text">
                {moment(createdAt).format('DD/MM/YYYY')}
            </p>
        </div>
    )
}

export default AccountInfo
